export default __webpack_public_path__ + "images/special-badge-blocked.svg";